import { z } from "zod";
import { MessageNodeFieldTypeEnum } from "../../../../enum/nodes.enum";

export const messageNodeQuickReplySchema = z.object({
  type: z.literal(MessageNodeFieldTypeEnum.QUICK_REPLY),
  quickReplyLabel: z.string().min(1, "Please enter valid label"),
  quickReplyMessage: z.string().min(1, "Please enter valid message"),
});

export type MessageNodeQuickReplySchema = z.infer<
  typeof messageNodeQuickReplySchema
>;
